export default {
    Paging: {
        Total: "Tổng số bản ghi",
        TotalQuantity: "Tổng TS",
        TotalAmount: "Giá trị TS",
        From: "Từ",
        To: "đến",
        Records: "bản ghi",
        Status: 'Thống kê tình trạng',
    },
    Date: {
        Month0: "Tháng 1",
        Month1: "Tháng 2",
        Month2: "Tháng 3",
        Month3: "Tháng 4",
        Month4: "Tháng 5",
        Month5: "Tháng 6",
        Month6: "Tháng 7",
        Month7: "Tháng 8",
        Month8: "Tháng 9",
        Month9: "Tháng 10",
        Month10: "Tháng 11",
        Month11: "Tháng 12",
        ToDay: "Hôm nay",
        Cancel: "Hủy bỏ",
        Time: "Thời gian:",
        DayOfWeek0: "T2",
        DayOfWeek1: "T3",
        DayOfWeek2: "T4",
        DayOfWeek3: "T5",
        DayOfWeek4: "T6",
        DayOfWeek5: "T7",
        DayOfWeek6: "CN"
    },
    Combobox: {
        EmptyText: "Nhấn Enter để thêm mới",
        SelectAllItemText: "<<Tất cả>>"
    },
    HeaderOption: {
        QuickAddText: "Thêm mới (F9)",
        QuickSearchText: "Tìm nhanh (F3)",
        IsBalanceInventory: "Chỉ hiển thị hàng hóa còn tồn",
        MsCombobox_EmptyTextDefault: "Không có dữ liệu hiển thị.",
        MsGrid_NoData: "Không có dữ liệu",
        Filter: {
            Contains: "Chứa",
            Notcontains: "Không chứa",
            StartsWith: "Bắt đầu",
            NotStartsWith: "Không bắt đầu",
            EndsWith: "Kết thúc",
            NotEndsWith: "Không kết thúc",
            Null: "Trống",
            NotNull: "Không trống",
            Equals: "Bằng",
            NotEquals: "Không bằng",
            GreaterThan: "Lớn hơn",
            GreaterThanEquals: "Lớn hơn hoặc bằng",
            LessThan: "Nhỏ hơn",
            LessThanEquals: "Nhỏ hơn hoặc bằng"
        },
        FilterBtn: "Áp dụng",
        ResetBtn: "Bỏ lọc",
        Pin: "Cố định cột này",
        Unpin: "Bỏ cố định cột này",
        ColumnLabel: "Điều kiện lọc",
        InputEmptyText: "Giá trị",
        InputEmptyFrom: "Từ giá trị",
        InputEmptyTo: "Đến",
        Boolean: {
            All: "Tất cả",
            True: "Có",
            False: "Không"
        },
        SortOrderColumn: "STT"
    },
    DatePicker: {
        MonthYear: "Tháng {0} năm {1}"
    },
    Grid: {
        FooterText: "Tổng"
    }
};
